import fetchData from './fetchData'
import { parseJSON, checkHttpStatus } from '../shared/utils'
import config from '../config/index'

async function actionGetCount(params, payload) {
  const { search } = params

  return fetchData(
    `${config.api.baseUrl}?class=action&action=getcount&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function actionGetPage(params, payload) {
  const {
    current, pageSize, search, sort, order,
  } = params

  return fetchData(
    `${config.api.baseUrl}?class=action&action=getpage&current=${current}&pageSize=${pageSize}&sort=${sort}&order=${order}&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function actionCreate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=action&action=create`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function actionRead(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=action&action=read&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function actionUpdate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=action&action=update`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function actionDelete(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=action&action=delete&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

export {
  actionGetCount,
  actionGetPage,
  actionCreate,
  actionRead,
  actionUpdate,
  actionDelete,
}



// WEBPACK FOOTER //
// src/api/action.js